import {
  AirplaneTiltIcon as BaseAirplaneTiltIcon,
  AirplaneTakeoffIcon as BaseAirplaneTakeoffIcon,
  AirplaneLandingIcon as BaseAirplaneLandingIcon,
} from "@phosphor-icons/react";

import { addRtlSupport } from "./utils/addRtlSupport";

export const AirplaneTiltIcon = addRtlSupport(BaseAirplaneTiltIcon);
export const AirplaneTakeoffIcon = addRtlSupport(BaseAirplaneTakeoffIcon);
export const AirplaneLandingIcon = addRtlSupport(BaseAirplaneLandingIcon);
